import { render, staticRenderFns } from "./creditCompare.vue?vue&type=template&id=1d72fc35"
import script from "./creditCompare.vue?vue&type=script&lang=js"
export * from "./creditCompare.vue?vue&type=script&lang=js"
import style0 from "./creditCompare.vue?vue&type=style&index=0&id=1d72fc35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports